import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './DisplayTitle.module.css';

export type DisplayLevel = 1 | 2 | 3;
export type DisplaySize = 'sm' | 'md' | 'lg' | 'xl';

export interface DisplayTitleProps {
  children: ReactNode;
  /** Nivel SEMANTICO del heading. Independiente del tamano visual. */
  level?: DisplayLevel;
  size?: DisplaySize;
  /** Tinta. `gold` para la palabra en oro de los mockups. */
  ink?: 'navy' | 'gold' | 'tone';
  /** Linea manuscrita (Allura) que cuelga del titular. */
  scriptLine?: string | null;
  align?: 'start' | 'center';
  /** Todo en mayusculas, como "NUEVA HUMANIDAD" o "LEVEL UP:". */
  uppercase?: boolean;
  id?: string;
  className?: string;
}

/**
 * Titular display del sistema. El TAMANO y el NIVEL van separados a proposito:
 * una pagina puede necesitar un `h2` enorme sin romper la jerarquia de headings
 * (criterio de a11y del gate de Fase 2).
 */
export function DisplayTitle({
  children,
  level = 2,
  size = 'lg',
  ink = 'navy',
  scriptLine = null,
  align = 'start',
  uppercase = false,
  id,
  className,
}: DisplayTitleProps) {
  const Tag = `h${level}` satisfies 'h1' | 'h2' | 'h3';
  return (
    <Tag
      id={id}
      className={cx(
        styles.title,
        styles[`size-${size}`],
        styles[`ink-${ink}`],
        styles[`align-${align}`],
        uppercase && styles.uppercase,
        className,
      )}
    >
      {children}
      {scriptLine ? <span className={cx('az-script', styles.script)}>{scriptLine}</span> : null}
    </Tag>
  );
}
